import React from "react";

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer
      style={{
        backgroundColor: "#F3F3F6",
        color: "#808080",
        textAlign: "center",
        padding: "12px",
        // position: "fixed",
        position:'relative',
        left: 0,
        bottom: 0,
        width: "100%",
        fontSize: "14px",
      }}
    >
      <p style={{padding:'0', margin:'0', fontSize:'13px'}}>&copy; {currentYear} RLA Agency, West Sumatra.</p>
      {/* <p>
        Made with ❤️ by{" "}
        <a
          href="https://yourwebsite.com"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "#61dafb", textDecoration: "none" }}
        >
          Your Name
        </a>
      </p> */}
    </footer>
  );
}

export default Footer;